module.exports = __webpack_public_path__ + "assets/img/4eab2c5551fee39614d78e3a1bcc4898.svg";